<template>
    <div class="row-zsb1">
      <div class="wp">
        <ul class="ul-tabsb1" v-if="childList && childList.length">
          <li
            :class="[childList[0].id == curid ? 'on' : '']"
            @click="getAllShare"
          >
            <span>{{ childList[0].name }}</span>
          </li>
          <li
            v-for="item of childList.slice(1)"
            :key="item.id"
            :class="[item.id == curid ? 'on' : '']"
            @click="switchType(item.id)"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <ul
          class="ul-listb1"
          v-if="
            contentList && contentList.records && contentList.records.length
          "
        >
          <li v-for="item of contentList.records" :key="item.id">
            <a
              :href="item.linkTo"
              target="_blank"
              class="con"
              v-if="item.linkTo"
            >
              <div class="pic">
                <img :src="imageUrl + item.contentImg" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ item.contentTitle }}</div>
                <div class="desc">
                  {{ item.summary }}
                </div>
              </div>
            </a>
            <div class="con" @click="toDetail(item.id)" v-else>
              <div class="pic">
                <img :src="imageUrl + item.contentImg" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ item.contentTitle }}</div>
                <div class="desc">
                  {{ item.summary }}
                </div>
                <!--  <div @click="toDetail(item.id)"  class="see">
                                    {{ $t("share.btn") }}
                                </div> -->
              </div>
            </div>
          </li>

        </ul>
        <el-empty v-else :description="$t('recruit.desc')"></el-empty>
        <div class="pages" v-if="total && total > size">
          <ul>
            <li class="prev" :class="[curPage == 1 ? 'hide' : '']">
              <span @click="prevPage">&lt;</span>
            </li>
            <li
              :class="[curPage == index + 1 ? 'on' : '']"
              v-for="(item, index) of pages"
              :key="index"
            >
              <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
            </li>
            <li class="next" :class="[curPage == pages ? 'hide' : '']">
              <span @click="nextPage">&gt;</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  data () {
    return {
      loading: true,
      result: null,
      shareRes: [],
      childList: [],
      contentList: [],
      pages: '',
      size: '',
      curPage: '',
      total: '',
      langKey: 'cn',

      pageInfo: {
        zhId: '1436536586652585986',
        enId: '1436536559276363778'
      }
    }
  },
  mounted () {
    let that = this;
    localStorage.setItem("locale",'en')
    let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang;

    Loading.service();
    if (that.$i18n.locale === 'zh') {
      that.langKey = 'cn';
      that.getShare(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.langKey = 'en';
      that.getShare(that.pageInfo.enId);
    }
    that.getShare(that.pageInfo.enId);
  },
  watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.langKey = 'cn';
        this.getShare(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.langKey = 'en';
        this.getShare(this.pageInfo.enId);
      }
    }
  },
  methods: {
    // 跳转至详情页
    toDetail (id) {
      let that = this
      that.$router.push({ name: 'shareDetails', query: { id: id }, params: {  type: '3' } })
    },
    // 获取知识分享信息
    getShare (id) {
      let that = this;
      let data = {
        id: id
      };

      that.$http
        .getShare(data)
        .then((res) => {
          if (res.code == 200) {
            // console.log(res);
            let result = res.result;
            that.result = result;

            let dataConfigs = JSON.parse(result.dataConfigs).configs[0];
            let url = dataConfigs.path
            let pid = dataConfigs.params.pid

            that.childurl = JSON.parse(result.dataConfigs).configs[1].path

            that.$axios.get(url, {
              params: {
                "pid": pid,

              }
            }).then(function (res) {
              if (res.status == 200) {
                // "category_sort" 通过该参数排列
                that.childList = res.data.result.records.sort(function (a, b) {
                  return a.categorySort < b.categorySort ? 1 : -1
                })
                that.curid = that.childList[0].id
                let isOne = true
                if (that.lang == 'en') {
                  that.childList.map(item => {
                    if (item.name.toLowerCase() == 'all') {

                      //获取全部数据
                      isOne = false
                      that.getAllShare()
                      return false;
                      }
                    });
                    if (isOne) {
                      that.switchType(that.curid);
                    }
                }else{
                  that.childList.map(item => {
                    if (item.name == '全部') {
                      //获取全部数据
                      isOne = false
                      that.getAllShare()
                      return false;
                      }
                    });
                    if (isOne) {
                      that.switchType(that.curid);
                    }
                }




              }
            });
          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },

    // 获取全部分类信息
    getAllShare () {
      let that = this;
      that.curid = that.childList[0].id
      let data = {
        langKey: that.langKey
      };
      that.$http
        .getAllShare(data)
        .then((res) => {
          if (res.code == 200) {
            that.contentList = res.result
            that.pages = res.result.pages
            that.curPage = res.result.current
            that.total = res.result.total
            that.size = res.result.size
            Loading.service().close();
          }
        })
        .catch((err) => {
          Loading.service().close();
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },

    // 切换分类
    switchType (childId) {
      let that = this;
      that.curid = childId
      that.contentList = []
      that.getList();
    },

    // 获取分类下列表
    getList (page) {
      Loading.service();
      let that = this;
      that.$axios.get(that.childurl, {
        params: {
          "categoryId": that.curid,
          "pageNo": page || 0,
          "column": 'orderNumber',
          "order": 'desc',
          'pageSize': 12,
          "status": 2,
          "contentDisplay": 1
        }
      }).then(function (res) {
        if (res.status == 200) {
          that.contentList = res.data.result
          that.pages = res.data.result.pages
          that.curPage = res.data.result.current
          that.total = res.data.result.total
          that.size = res.data.result.size
          Loading.service().close();
        }
      }).catch(function (err) {
        that.$message(
          {
            message: err,
            type: 'error'
          }
        );
      });
    },

    navToPage (page) {
      let that = this;
      that.curPage = page
      that.getList(page);
    },
    prevPage () {
      let that = this;
      let prevPage = that.curPage - 1;
      that.curPage = prevPage
      if (prevPage < 1) {
        prevPage = 1
        that.curPage = 1
        return false;
      }
      that.getList(prevPage);
    },
    nextPage () {
      let that = this;
      let nextPage = that.curPage + 1;
      that.curPage = nextPage
      if (nextPage > that.pages) {
        nextPage = that.pages
        that.curPage = that.pages
        return false;
      }
      that.getList(nextPage);
    },

  },
}
</script>

<style>
</style>
